module.exports = __webpack_public_path__ + "img/usa.44cef35d.svg";